// extracted by mini-css-extract-plugin
export var notificationHost = "_d5-0";